import { apiClient, assertOk } from "@/api/generated/client.ts"
import type { Unit } from "@/types/unitTypes.ts"

export const getUnits = async (): Promise<Unit[]> => {
  const { data, error, response } = await apiClient.GET("/api/Units")
  return assertOk(response, error, data)
}
